var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024 1536q150 0 292 -39t272.5 -107.5t246 -162.5t213.5 -203q-98 -110 -213.5 -203.5t-246 -162t-272.5 -107.5t-292 -39t-292 39t-272.5 107.5t-246.5 162t-213 203.5q97 109 213 203t246.5 162.5t272.5 107.5t292 39zM1408 1024q0 79 -30.5 149t-82.5 122t-122 82.5 t-149 30.5t-149 -30.5t-122 -82.5t-82.5 -122t-30.5 -149t30.5 -149t82.5 -122t122 -82.5t149 -30.5t149 30.5t122 82.5t82.5 122t30.5 149zM177 1024q94 -91 200 -166.5t227 -126.5q-45 64 -68.5 139.5t-23.5 153.5t23.5 153.5t68.5 139.5q-121 -51 -227 -126.5 t-200 -166.5zM1444 731q121 51 227 126.5t200 166.5q-94 91 -200 166.5t-227 126.5q45 -64 68.5 -139.5t23.5 -153.5t-23.5 -153.5t-68.5 -139.5zM1024 896q-27 0 -50 10t-40.5 27.5t-27.5 40.5t-10 50t10 50t27.5 40.5t40.5 27.5t50 10t50 -10t40.5 -27.5t27.5 -40.5 t10 -50t-10 -50t-27.5 -40.5t-40.5 -27.5t-50 -10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.33bc0673.svg";
export { ForwardRef as ReactComponent };